import { render, staticRenderFns } from "./SmallSidebar.vue?vue&type=template&id=07aeea75&"
import script from "./SmallSidebar.vue?vue&type=script&lang=js&"
export * from "./SmallSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports